module.exports = __webpack_public_path__ + "static/media/unionplus.0916d646.svg";